<div
  class="ai-banner"
  *ngIf="
    isBrowser &&
    !(charityLoading$ | async) &&
    currentRoutePath.includes('/tv/') &&
    currentRoutePath.includes('/live/')
  "
>
  <div class="ai-banner-content">
    <h1>
      Try {{ (charity$ | async)?.settings?.enable_incognito ? 'AI' : 'GiveBrite AI' }}
      <ui-icon name="sparkles" [size]="24" class="ml-1"></ui-icon> Today!
    </h1>

    <button type="button" class="btn btn-primary ml-6" (click)="fundraise()">
      Create campaign
    </button>
  </div>
</div>
<router-outlet></router-outlet>

@if (signingOut$ | async) {
  <div
    class="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-4 bg-base-100/50 backdrop-blur-xs"
    role="status"
  >
    <div class="card bg-base-100 shadow-xl">
      <div class="card-body items-center justify-center gap-4 px-12">
        <ui-loading type="spinner" size="lg"></ui-loading>
        <p class="text-base font-medium text-base-content">Signing out</p>
      </div>
    </div>
  </div>
}
